"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaMempoolResponseToJSON = exports.RosettaMempoolResponseFromJSONTyped = exports.RosettaMempoolResponseFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function RosettaMempoolResponseFromJSON(json) {
    return RosettaMempoolResponseFromJSONTyped(json, false);
}
exports.RosettaMempoolResponseFromJSON = RosettaMempoolResponseFromJSON;
function RosettaMempoolResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'transaction_identifiers': (json['transaction_identifiers'].map(_1.TransactionIdentifierFromJSON)),
        'metadata': !runtime_1.exists(json, 'metadata') ? undefined : json['metadata'],
    };
}
exports.RosettaMempoolResponseFromJSONTyped = RosettaMempoolResponseFromJSONTyped;
function RosettaMempoolResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'transaction_identifiers': (value.transaction_identifiers.map(_1.TransactionIdentifierToJSON)),
        'metadata': value.metadata,
    };
}
exports.RosettaMempoolResponseToJSON = RosettaMempoolResponseToJSON;
//# sourceMappingURL=RosettaMempoolResponse.js.map